import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Select from 'modules/core/components/Select'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type Company from 'modules/core/store/models/Company'

import CompanyGeneralForm from 'modules/settings/lib/forms/General'

import { industryOptions, mapIndutry } from './industryOptions'

export interface Props {
  company: Company
}

const GeneralCompanyForm = ({ company }: Props) => {
  const form = useLazyRef(() => {
    const companyData = company.toJS()
    companyData.industry = mapIndutry(companyData.industry)
    return new CompanyGeneralForm(companyData)
  }).current

  const sortedIndustries = industryOptions().sort((a, b) => {
    return a.label.localeCompare(b.label)
  })

  const onSubmit = async () => {
    if (!form.isDirty) return

    await asyncAction(() => form.save(company), {
      errorFlash: false,
    })
  }

  return (
    <Section.Form
      illustration="building"
      title={i18n.t('settings.edit_company.general_form.title')}
      description={i18n.t('settings.edit_company.general_form.description')}
      onSubmit={onSubmit}
      isDirty={form.isDirty}
      submitLabel={i18n.t('common.submit')}
      paddingX="s0"
    >
      <Text
        mandatory
        label={i18n.t('settings.edit_company.company_name')}
        placeholder={i18n.t('common.company_name')}
        field={form.get('name')}
      />
      <Select
        label={i18n.t('settings.edit_company.company_industry')}
        none={i18n.t('common.select')}
        value={form.get('industry').value}
        onChange={(value) => form.get('industry').set(value)}
        options={sortedIndustries}
        mandatory
      />
    </Section.Form>
  )
}

export default observer(GeneralCompanyForm)
